import { inject, Injectable } from '@angular/core';
import { GenericFeatureFlagService } from '@rma/generic/ng/feature-flags/internal';
import { Observable } from 'rxjs';
import { FeatureFlag } from '../domain/feature-flags.enum';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  private readonly internalFlagService = inject(GenericFeatureFlagService<FeatureFlag>);

  public getFeature<T = boolean>(key: FeatureFlag, defaultValue: T): T {
    return this.internalFlagService.getFeature(key, defaultValue);
  }

  public getFeature$<T = boolean>(key: FeatureFlag, defaultValue: T): Observable<T> {
    return this.internalFlagService.getFeature$(key, defaultValue);
  }

  public getLiveFeature$<T = boolean>(key: FeatureFlag, defaultValue: T): Observable<T> {
    return this.internalFlagService.getLiveFeature$(key, defaultValue);
  }
}
